import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

export const DEFAULT_BRANDING = {
  company_name: "Masterbuilt Roofing",
  tagline: "Built For You",
  logo_url: "https://customer-assets-rejwkqb3.emergentagent.net/job_built-manager/artifacts/ay54zpmd_file_000000000e0c71fdbd47477fe76ecb58.png",
  phone: "", email: "", website: "", address: "", license: "",
  primary_color: "#0B2545", accent_color: "#C8102E",
};

const BrandingCtx = createContext({ branding: DEFAULT_BRANDING, refresh: () => {} });
export const useBranding = () => useContext(BrandingCtx);

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);
  const refresh = useCallback(() => {
    return api.get("/branding/public")
      .then((r) => setBranding({ ...DEFAULT_BRANDING, ...(r.data || {}) }))
      .catch(() => {});
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  // Live-theme the app from the brand's primary/accent colors.
  useEffect(() => {
    const toRgb = (hex) => { const m = /^#?([0-9a-f]{6})$/i.exec(hex || ""); if (!m) return null; const n = parseInt(m[1], 16); return `${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255}`; };
    const p = toRgb(branding.primary_color); const a = toRgb(branding.accent_color);
    if (p) document.documentElement.style.setProperty("--brand-primary", p);
    if (a) document.documentElement.style.setProperty("--brand-accent", a);
  }, [branding.primary_color, branding.accent_color]);

  return <BrandingCtx.Provider value={{ branding, refresh }}>{children}</BrandingCtx.Provider>;
}
